import { FONT_FAMILY, FONT_SIZE, FONT_STYLE } from 'src/lib/player/constants';
import type { StarterType, XY } from 'src/lib/player/store';
import type { Bounds } from '../InfoSheet/SVGChart';
import {
  type ViewRange,
  getInterpolatedElevation,
  getInterpolatedY,
  isDataXInView,
  projectX,
} from './heightChartUtils';

export function HeightChartStarter({
  starterOffset,
  starter,
  bounds,
  viewRange,
  filteredTrack,
  lineColor,
}: {
  starterOffset: number;
  starter: StarterType;
  bounds: Bounds;
  viewRange: ViewRange;
  filteredTrack: Array<XY>;
  lineColor: string;
}) {
  if (Number.isNaN(starterOffset)) return null;
  if (!isDataXInView(starterOffset, viewRange)) return null;
  const { minY, maxY } = viewRange;
  const starterLineX = projectX(starterOffset, viewRange, bounds);
  const elevation = getInterpolatedElevation(filteredTrack, starterOffset);
  const lowerY = getInterpolatedY(elevation, minY, maxY, bounds);
  const upperY = Math.max(0, lowerY - 50);
  return (
    <>
      <text
        x={starterLineX + 4}
        y={upperY + 11}
        style={{
          fontWeight: FONT_STYLE,
          fontFamily: FONT_FAMILY,
          fontSize: FONT_SIZE,
          textAlign: 'left',
          textAnchor: 'start',
          fill: lineColor,
        }}
      >
        {starter.startNumber}
      </text>
      <line
        x1={starterLineX}
        x2={starterLineX}
        y1={upperY + 1}
        y2={lowerY}
        stroke={starter.markerColor.hex}
        strokeWidth={2}
      />
    </>
  );
}
